import React from 'react'
import "./index.css"
function InfoCard() {
  return (
    <section className="section-info">
                    <div>
                        <div>
                            <h1 className="learn-code-h1">
                                Learn to code by <br></br>
                                watching others
                            </h1>
                        </div>
                        <div>
                            <p className="p-info-card">
                                See how experienced developers solve 
                                problems in real-time. Watching 
                                scripted tutorials is great, but understanding how
                                developers think is invaluable.
                            </p>
                        </div>
                    </div>
                </section>
  )
}

export {InfoCard}